// extracted by mini-css-extract-plugin
export default {"inputContainer":"VerificationCode_inputContainer__JA5-8","inputField":"VerificationCode_inputField__cWz03"};